import React, { useEffect, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

const NetworkStatusNotifier = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [open, setOpen] = useState(!navigator.onLine); // Show if offline at start

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setOpen(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setOpen(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleClose = () => {
    if (isOnline) setOpen(false); // only allow closing if online
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={isOnline ? 3000 : null}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity={isOnline ? 'success' : 'error'}
        sx={{ width: '100%' }}
        onClose={isOnline ? handleClose : undefined}
      >
        {isOnline ? 'You are back online!' : 'You are offline. Trying to reconnect...'}
      </Alert>
    </Snackbar>
  );
};

export default NetworkStatusNotifier;
